/* @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './ChartLegend.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

class ChartLegend extends React.Component<*> {
  render(): React.Element<*> {
    const hasTransformClass: string = this.props.transformKeys ? styles['has-transform'] : '';

    return (
      <ul
        className={`${styles['chart-legend']} ${styles[this.props.position]} ${hasTransformClass}`}
        style={this.props.style}
      >
        {this.props.keys
          ? this.props.keys.map((legendItem: any) => {
              return (
                <React.Fragment key={legendItem.label}>
                  <li>
                    <span style={{ backgroundColor: legendItem.color }} /> {legendItem.label}
                  </li>
                </React.Fragment>
              );
            })
          : null}
      </ul>
    );
  }
}

export default ChartLegend;
